import apiClient from "../../../utilities/apiClient";

export const addCommodityGroup = (payload) => {
  return apiClient.post(`${apiClient.Urls.commodity_group}`, payload, true);
};

export const getCommodityGroups = (page, per_page, search) => {
  return apiClient.get(
    `${apiClient.Urls.commodity_group}?page=${page}&per_page=${per_page}&search=${
      search || ""
    }`,
    "",
    true
  );
};

export const updateCommodityGroup = (id, payload) => {
  return apiClient.put(`${apiClient.Urls.commodity_group}/${id}`, payload, true);
};

export const deleteCommodityGroup = (id) => {
  return apiClient.delete(`${apiClient.Urls.commodity_group}/${id}`, {}, true);
};
